<script setup lang="ts">
import KBtn from '@/components/btns/KBtn.vue';
import ReportGenerateDialogHeader from '@/components/headers/ReportGenerateDialogHeader.vue';
import PageDialogWrapper from '@/components/wrappers/PageDialogWrapper.vue';

import dialog from '@/styles/jobEditDialog.module.scss';

export interface Props {
  isConfirmLoading?: boolean;
  isLocked?: boolean;
  confirm?: () => Promise<unknown>;
}
export type DefProps = typeof props;

const props = withDefaults(defineProps<Props>(), {
  isConfirmLoading: false,
  isLocked: false,
  confirm: undefined,
});

const emit = defineEmits<{
  cancelBtnClick: [event: Event];
  confirmBtnClick: [event: Event, props: DefProps];
}>();

function handleCancelClick(event: Event): void {
  if (props.isConfirmLoading) return;
  emit('cancelBtnClick', event);
}

function handleConfirmClick(event: Event): void {
  if (props.isConfirmLoading) return;
  emit('confirmBtnClick', event, props);
}
</script>

<template>
  <PageDialogWrapper
    :class="[$style.jobEditLockJobDialog, dialog.dialogRoot]"
    data-testid="jobEditLockJobDialog"
  >
    <template #header>
      <ReportGenerateDialogHeader @close-click="handleCancelClick">
        {{ props.isLocked ? 'Unlock Job' : 'Lock Job' }}
      </ReportGenerateDialogHeader>
    </template>

    <section>
      <div :class="dialog.text">
        {{
          props.isLocked
            ? 'Unlock this job to allow further changes?'
            : 'Lock this job to prevent further changes?'
        }}
      </div>
    </section>

    <template #footer>
      <menu :class="dialog.dialogFooterMenuList">
        <li :class="dialog.dialogFooterMenuListItem">
          <KBtn
            variant="outlined"
            append-icon="mdi-close"
            :disabled="props.isConfirmLoading"
            @click="handleCancelClick"
          >
            Cancel
          </KBtn>
        </li>
        <li :class="dialog.dialogFooterMenuListItem">
          <KBtn
            :append-icon="props.isLocked ? 'mdi-lock-open' : 'mdi-lock'"
            :loading="props.isConfirmLoading"
            @click="handleConfirmClick"
          >
            {{ props.isLocked ? 'Unlock Job' : 'Lock Job' }}
          </KBtn>
        </li>
      </menu>
    </template>
  </PageDialogWrapper>
</template>

<style module lang="scss">
@use '@/styles/variables';

.jobEditLockJobDialog {
  width: variables.$reportGenerateDialogWidth;
}
</style>
